import request from './axiosClient';
import { itemInputOrderByImgSlideRank } from 'models';

const URL_RANKING_PUBLIC = '/v2/ranking-public';
const URL_ORDER_BY_RANKING = '/order-by-ranking';
const URL_GET_RANKING = '/v2/ranking';
const URL_IMAGE_SLIDER = '/image-slider';
const URL_IMAGE_SLIDER_V2 = '/v2/image-slider';
const URL_SETTING_AVATAR_RANKING = '/setting-avatar-ranking';
const URL_GET_HOST_FOR_ORDER_LIST = '/user-of-shop';
const URL_IMG_RANK = '/image-rank';
const URL_NOTE_APP_RANKING = '/note-app-ranking';
const URL_DATE_OF_DATA = '/date-of-data';
const URL_ORDER_BY_IMAGES_SLIDER_RANKING_V3 = '/v3/order-by-images-slider-ranking';
const URL_PROGRAM_RANK_V2 = '/v2/program-rank';
// v2 old, change v3 since 25/2/2026
const URL_RANKING_PUBLIC_GROUP_SHOP_V2 = '/v2/ranking-public-list-shop';
const URL_RANKING_PUBLIC_GROUP_SHOP_V3 = '/v3/ranking-public-list-shop';

//18/12/2025 get multiple program rank
const URL_ORDER_BY_IMAGES_SLIDER_RANKING = '/order-by-images-slider-ranking';
const URL_PROGRAM_RANK = '/program-rank';

export function updateImageSliderAPI(token: string, data: any) {
  return request({
    url: URL_IMAGE_SLIDER + '/0',
    method: 'PUT',
    token,
    data,
  });
}
export function fetchRankingAPI(token: string, params: any) {
  return request({
    url: URL_GET_RANKING,
    method: 'get',
    params,
    token,
  });
}
export function getOrderByRankingInPosRankingAPI(
  token: string,
  params: { shop_id?: string; permission?: string }
) {
  return request({
    url: URL_ORDER_BY_RANKING,
    method: 'get',
    token,
    params,
  });
}
export function updateOrderByRankingInPosRankingAPI(token: string, data: any) {
  return request({
    url: URL_ORDER_BY_RANKING,
    method: 'POST',
    token,
    data,
  });
}
export function deleteImageSliderAPI(token: string, id: any, data: any) {
  return request({
    url: URL_IMAGE_SLIDER + `/${id}`,
    method: 'DELETE',
    token,
    data,
  });
}
export function updateImageSettingAvatarRankingAPI(token: string, data: any) {
  return request({
    url: URL_SETTING_AVATAR_RANKING,
    method: 'post',
    token,
    data,
    isFormData: true,
  });
}

export function addImageSliderAPI(token: string, data: any) {
  return request({
    url: URL_IMAGE_SLIDER,
    method: 'post',
    token,
    data,
    isFormData: true,
  });
}
export function fetchHostForOrderListAPI(
  token: string,
  params: { shopId: any; is_host: any; key: any; status: any; group_id: any; per_page: 1000 }
) {
  return request({
    url: URL_GET_HOST_FOR_ORDER_LIST,
    method: 'get',
    params,
    token,
  });
}
export function getImageSliderAPI(token: string, params: any) {
  return request({
    url: URL_IMAGE_SLIDER,
    method: 'get',
    token,
    params,
  });
}
export function getImageSliderV2API(token: string, params: any) {
  return request({
    url: URL_IMAGE_SLIDER_V2,
    method: 'get',
    token,
    params,
  });
}
export function getRankingDatePublicAPI(token: any, params: any) {
  return request({
    url: URL_RANKING_PUBLIC,
    method: 'get',
    token,
    params: {
      ...params,
      appName: 'web_rank',
    },
  });
}
export function getRankingMonthPublicAPI(token: any, params: any) {
  return request({
    url: URL_RANKING_PUBLIC,
    method: 'get',
    token,
    params: {
      ...params,
      appName: 'web_rank',
    },
  });
}
export function getRankingPublicGroupShopAPI(token: any, params: any) {
  return request({
    url: URL_RANKING_PUBLIC_GROUP_SHOP_V2,
    method: 'get',
    token,
    params: {
      ...params,
      appName: 'web_rank',
    },
  });
}
export function updateImageShowRankingAPI(token: string, data: any) {
  return request({
    url: URL_IMG_RANK,
    method: 'post',
    token,
    data,
    isFormData: true,
  });
}

export function getImageShowRankingAPI(token: string, params: any) {
  return request({
    url: URL_IMG_RANK,
    method: 'get',
    token,
    params,
  });
}
export function getNoteAppRankingAPI(token: string, params: any) {
  return request({
    url: URL_NOTE_APP_RANKING,
    method: 'get',
    token,
    params,
  });
}

export function updateNoteAppRankingAPI(token: string, data: any) {
  return request({
    url: URL_NOTE_APP_RANKING,
    method: 'post',
    token,
    data,
  });
}
export function getRankingDateHaveDataApi(token: string, shop_id: number) {
  return request({
    url: URL_DATE_OF_DATA,
    params: {
      shop_id,
    },
    method: 'get',
    token,
  });
}
export function getOrderByImagesSliderRankingApi(
  token: string,
  shop_id: number,
  program_rank_id?: number,
  permission?: string
) {
  return request({
    url: URL_ORDER_BY_IMAGES_SLIDER_RANKING_V3,
    params: {
      shop_id,
      program_rank_id,
      permission,
    },
    method: 'get',
    token,
  });
}

export function updateOrderByImagesSliderRankingApi(
  token: string,
  shop_id?: number,
  shop_ids?: number[],
  input?: itemInputOrderByImgSlideRank[],
  type_update?: number
) {
  return request({
    url: URL_ORDER_BY_IMAGES_SLIDER_RANKING,
    method: 'post',
    token,
    data: {
      ...(shop_ids && shop_ids.length > 0 ? { shop_ids } : shop_id ? { shop_id } : {}),
      input,
      type_update,
    },
  });
}

export function deleteOrderByImagesSliderRankingApi(
  token: string,
  id: number,
  shop_id?: number,
  type_delete?: number
) {
  return request({
    url: `${URL_ORDER_BY_IMAGES_SLIDER_RANKING}/${id}`,
    method: 'delete',
    token,
    data: {
      shop_id,
      type_delete,
    },
  });
}

export function getProgramRankAPI(token: string, params: any) {
  return request({
    url: URL_PROGRAM_RANK_V2,
    method: 'get',
    token,
    params,
  });
}

export function createProgramRankAPI(token: string, data: any) {
  return request({
    url: URL_PROGRAM_RANK,
    method: 'post',
    token,
    data,
  });
}

export function updateProgramRankAPI(token: string, id: number, data: any) {
  return request({
    url: URL_PROGRAM_RANK + `/${id}`,
    method: 'put',
    token,
    data,
  });
}
export function deleteProgramRankAPI(token: string, id: number, shop_id: number) {
  return request({
    url: `${URL_PROGRAM_RANK}/${id}`,
    method: 'delete',
    token,
    data: { shop_id },
  });
}
